export const routes = [
  {
    path: "/radar-execucao",
    name: "radar-execucao",
    component: () => import(/* webpackChunkName: "radar-execucao" */ "./components/RadarExecucao.vue"),
    meta: { requiresAuth: true, requiresRadarExecucao: true },
  },
];
